import React from "react";
import { Link } from "react-router-dom";
import BookCallButton from "../../BookCallButton/BookCallButton";

const cardStyle = {
  border: "1px solid #ededed",
  borderRadius: "8px",
  padding: "30px",
  height: "100%",
};

const StaffAugRates = () => {
  return (
    <section className="staff-aug-rates section-gap">
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-lg-8 text-center">
            <p className="font-15 let-space-2">Indicative Pricing</p>
            <h2 className="font-50 font-w800 text-dark pb-3">
              Rates, as a Starting Point
            </h2>
            <p className="font-w300 text-grey">
              Every engagement is scoped to the actual role and seniority
              needed — these ranges are a starting point for that
              conversation, not a fixed price list.
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-md-5 mb-4">
            <div style={cardStyle}>
              <p className="font-25 font-w800 text-dark mb-1">Mid-Level</p>
              <p className="font-w300 text-grey mb-3">
                Product/UX Design or Frontend Engineering
              </p>
              <p className="font-45 font-w800 text-dark mb-0">
                $25&ndash;45
                <span className="font-20 font-w300 text-grey">/hr</span>
              </p>
            </div>
          </div>
          <div className="col-md-5 mb-4">
            <div style={cardStyle}>
              <p className="font-25 font-w800 text-dark mb-1">
                Senior / Design Systems Lead
              </p>
              <p className="font-w300 text-grey mb-3">
                For complex, high-ownership roles
              </p>
              <p className="font-45 font-w800 text-dark mb-0">
                $45&ndash;65
                <span className="font-20 font-w300 text-grey">/hr</span>
              </p>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center mt-2">
          <div className="col-auto mb-3">
            <BookCallButton />
          </div>
          <div className="col-auto mb-3">
            <Link to="/contact-us" className="primary-btn text-uppercase px-4">
              Talk to Us About Your Team
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StaffAugRates;
